export default __webpack_public_path__ + "static/media/image 10.ec33aaa6.svg";